import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import { toastService } from "../../utils/toastify";
export const getCourses = createAsyncThunk(
  "get/courses",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("courseList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);

export const addCourse = createAsyncThunk(
  "add/course",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addCourse", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      if (error?.response?.data?.code == 403) {
        toastService.error(error?.response?.data?.message);
        rejectWithValue(error);
      } else {
        toastService.error("Course added failed");
        rejectWithValue(error);
      }
    }
  }
);
export const updateCourse = createAsyncThunk(
  "edit/course",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editCourse", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const courseStatusChanged = createAsyncThunk(
  "changeStatus/course",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "courseStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
const coursesManagement = createSlice({
  name: "courses",
  initialState: {
    courses: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCourses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourses.fulfilled, (state, action) => {
      state.loading = false;
      state.courses = action.payload;
    });
    builder.addCase(getCourses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default coursesManagement.reducer;
